import {ref, onBeforeUnmount, onMounted, Ref} from '@vue/composition-api';
import {POISearchOption} from '@/store/api/search-poi';
import {deouncedPOISearch} from '@/store/api/search-explore-options';

import {getSolutionContext} from '@/store/state/helpers';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
import {AdditionalPoisModule} from '@/store/modules';

export function useFindPlaces(
  category: Ref<UserActivityCategoryEnum>,
  onShowDetails: (x: string) => void = () => null,
) {
  const searchValue = ref('');
  const searchOptions = ref<POISearchOption[]>([]);

  const clearSearchOptions = () => {
    searchOptions.value = [];
    searchValue.value = '';
  };

  onMounted(() => {
    document.addEventListener('click', clearSearchOptions);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', clearSearchOptions);
  });

  const searchPois = async (v: string) => {
    const solutionContext = getSolutionContext();
    const res = await deouncedPOISearch(v, category.value, solutionContext);
    searchOptions.value = res.slice(0, 20);
  };

  const onSearchChange = async (v: Event) => {
    const value = (v.target as HTMLInputElement)?.value;
    searchValue.value = value;
    searchPois(value);
  };

  const onSelectSearchPoi = async (item: POISearchOption) => {
    searchValue.value = '';
    searchOptions.value = [];
    await AdditionalPoisModule.fetchSourcePoi(item.id);
    onShowDetails(item.id);
  };

  return {searchValue, searchOptions, onSearchChange, onSelectSearchPoi, clearSearchOptions, searchPois};
}
